import { render, staticRenderFns } from "./pos-vendors.vue?vue&type=template&id=74b0548c"
import script from "./pos-vendors.vue?vue&type=script&lang=js"
export * from "./pos-vendors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports